/* global Omise */
import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import BookingAppBarComponent from '../../../component/booking_appbar';

import { getProvince, getDistricts, getSubDistrict, Getcountry, GetMaxpeopleSpecialday, GetSpecialDateTime, GetTimeSlotsByTime } from '../../../service/utinity_service';
import { AlertError, AlertLoading } from '../../../component/popupAlert';
import bg_pic from '../../../images/bg_website.png';
import './style_checkout.css';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next'; // เพิ่มบรรทัดนี้

import {
    Avatar,
    Card,
    CardContent,
    Grid,
    Typography,
    Button,
    Box,
    TextField,
    useMediaQuery,
    List,
    ListItem,
    Divider,
    FormGroup,
    Chip,
    FormControlLabel,
    Checkbox,
    Autocomplete,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    IconButton,
    InputAdornment
} from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

import { useTheme } from '@mui/material/styles';

import { v4 as uuidv4 } from 'uuid';
import { Rules } from './checkout_model';
import { AddTicketboat, CheckBoat, CreateSource, Getpayment } from '../../../service/booking_service';
import { accordionData } from './checkout_model';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const CheckoutView = () => {

    const navigate = useNavigate();
    const { t: title } = useTranslation('booking')
    const { t: rules } = useTranslation('condition');
    const { t: checkoutText } = useTranslation('checkout');

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
    const [province, setProvince] = useState([])
    const [district, setDistrict] = useState([])
    const [country, setCountry] = useState([])
    const [subdistrict, setSubdistrict] = useState([])
    const [districtDefaut, setDistrictDefaut] = useState([])
    const [subdistrictDefaut, setSubdistrictDefaut] = useState([])
    const [zip_code, setZipCode] = useState([])
    const [AutocompleteState, setAutocomplateState] = useState({
        district: false, setDistrict: false, zip_code: false
    }) //

    const [maxPeople, setMaxPeople] = useState(0)

    const [stateWallet, setStateWallet] = useState(false)

    const [isThai, setIsthai] = useState(true)

    const [expanded, setExpanded] = useState(false);
    const [checked, setChecked] = useState({
        Wallet_Payment: false,
        Credit: false,
        Mobile: false,
    });

    const [showCraditNumber, setShowCraditNumber] = useState(false);
    const [showCVV, setShowCVV] = useState(false);

    const [m_banking, setM_banking] = useState({})

    const [valid, setValid] = useState({
        first_name: false,
        last_name: false,
        email: false,
        tel: false,
        address: false,
        province: false,
        district: false,
        subdistrict: false,
        zip_code: false,
        address_details: false,
    })

    const [Creditvalid, setCreditValid] = useState({
        month: false,
        name: false,
        year: false,
        cvv: false,
        number: false,
    })

    const [formatDateState, setFormatDateState] = useState(false);

    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleBackClick = () => {
        navigate(-1); // ย้อนกลับไปหน้าที่แล้ว
    };

    const handleChecPeopleBoat = async (max, date, time) => {
        try {
            const res = await CheckBoat(date, time);
            console.log("maxPeople:", max);

            if (!res || !res.total_people) {
                console.log("No data from CheckBoat or total_people is missing.");
                return max;
            }

            const availablePeople = max - res.total_people;
            // console.log("CheckBoat data:", res);
            // console.log("Available People:", availablePeople);

            return availablePeople;
        } catch (error) {
            console.error("Error in handleChecPeopleBoat:", error);
            return max; // Return `max` as a fallback in case of error
        }
    };

    const handleCheckboxChange = (panel) => (event) => {
        const isChecked = event.target.checked;
        setStateWallet(false);
        setM_banking({})

        // สร้าง object ใหม่โดยให้ทุก panel เป็น false
        const newChecked = Object.keys(checked).reduce((acc, key) => {
            acc[key] = false;
            return acc;
        }, {});

        // ตั้งค่า panel ที่ถูกเลือกเป็น true (ถ้ามีการเลือก)
        newChecked[panel] = isChecked;

        setChecked(newChecked);

        if (isChecked) {
            setExpanded(panel);
        } else {
            setExpanded(false);
        }
    };

    const formatDateToThai = (dateString, options = {}) => {
        // console.log('formatDateToThai', dateString);

        if (!dateString) {
            return '';
        }

        try {
            const date = new Date(dateString);

            if (isNaN(date.getTime())) {
                throw new Error('Invalid date');
            }

            const day = String(date.getDate()).padStart(2, '0');

            const monthNamesThai = [
                'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
                'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
            ];

            const monthNamesThaiShort = [
                'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.',
                'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'
            ];

            const monthNamesEnglish = [
                'January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'
            ];

            const monthNamesEnglishShort = [
                'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
            ];

            let month
            if (Cookies.get('language') === "TH") {
                month = options.shortMonth
                    ? monthNamesThaiShort[date.getMonth()]
                    : monthNamesThai[date.getMonth()];
            } else {
                month = options.shortMonth
                    ? monthNamesEnglishShort[date.getMonth()]
                    : monthNamesEnglish[date.getMonth()];
            }

            const year = date.getFullYear() + 543; // Convert CE year to BE year

            let result = `${day} ${month}`;

            if (options.includeYear !== false) {
                result += ` ${year}`;
            }

            return result;

        } catch (error) {
            console.error('Error formatting date:', error);
            return 'Invalid Date';
        }
    };

    const [checkoutData, setCheckoutData] = useState({})
    const [checkboxValues, setCheckboxValues] = useState({
        serviceTerms: false,
        personalData: false,
        serviceUpdates: false
    });

    const [dataFetched, setDataFetched] = useState(false);
    const [formattedData, setFormattedData] = useState('')
    const [truePhone, setTruePhone] = useState('')
    const [caditData, setCaditData] = useState(
        {
            month: '',
            name: '',
            year: '',
            cvv: '',
            number: ''
        }
    )

    useEffect(() => {

        if (!dataFetched) {
            Omise.setPublicKey(process.env.REACT_APP_OMISE_PUBLIC_KEY)
            init();
            const language = Cookies.get('language');
            i18next.changeLanguage(language);
        }


        const time = Cookies.get('time');
        const date = Cookies.get('date');

        if (!time || !date) {
            // If time or date is missing, navigate to the home page
            navigate('/');
            return;
        }


        const adults = parseInt(Cookies.get('adults'), 10) || 0;
        const children = parseInt(Cookies.get('children'), 10) || 0;
        const discountAmount = 0;

        const adultPrice = Cookies.get('price_adult');
        const adultPriceBfVAT = Math.round((adultPrice / 1.07) * 100) / 100;
        const adultVAT = Math.round((adultPriceBfVAT * 7 / 100) * 100) / 100;
        const sumAdultPriceBfVAT = Math.round(((adultPriceBfVAT * adults)) * 100) / 100;
        const sumAdultVAT = Math.round(((adultVAT * adults)) * 100) / 100;
        const totalAdultPrice = Math.round((sumAdultPriceBfVAT + sumAdultVAT) * 100) / 100;

        const childrenPrice = Cookies.get("price_children")
        const childrenPriceBfVAT = Math.round((childrenPrice / 1.07) * 100) / 100;
        const childrendVAT = Math.round((childrenPriceBfVAT * 7 / 100) * 100) / 100;
        const sumChildrenPriceBfVAT = Math.round(((childrenPriceBfVAT * children)) * 100) / 100;
        const sumChildrenVAT = Math.round(((childrendVAT * children)) * 100) / 100;
        const totalChildrenPrice = Math.round((sumChildrenPriceBfVAT + sumChildrenVAT) * 100) / 100;

        const total_price = Math.round((totalAdultPrice + totalChildrenPrice) * 100) / 100;
        const total_vat = Math.round((sumAdultVAT + sumChildrenVAT) * 100) / 100;

        // console.log('Proceed with booking process');

        if (!dataFetched) {
            Omise.setPublicKey(process.env.REACT_APP_OMISE_PUBLIC_KEY);
            init();
        }

        const resDate = format(new Date(date), 'dd/MMMM/yyyy');
        setFormattedData(resDate);

        // console.log("date : ", resDate);

        setCheckoutData({
            id: uuidv4(),
            adults: adults,
            children: children,
            priceBeforeVAT: (sumAdultPriceBfVAT + sumChildrenPriceBfVAT),
            sumAdultPriceBfVAT: sumAdultPriceBfVAT,
            sumChildrenPriceBfVAT: sumChildrenPriceBfVAT,
            total_price: total_price,
            time: time,
            date: date,
            total_people: adults + children,
            vat: total_vat,
            discountAmount: discountAmount,
            create_date: new Date()
        })

    }, []);

    const init = async () => {
        try {

            const responseCountry = await Getcountry()
            setCountry(responseCountry)
            setCheckoutData(prevData => ({
                ...prevData,
                [country]: 764
            }));

            const responseProvince = await getProvince();
            setProvince(responseProvince);

            const responseAmphur = await getDistricts();
            if (districtDefaut == []) {
                setDistrict(responseAmphur)
            }
            setDistrictDefaut(responseAmphur);
            const responseSubDistrict = await getSubDistrict();
            if (districtDefaut == []) {
                setSubdistrict(responseSubDistrict)
            }
            setSubdistrictDefaut(responseSubDistrict);

        } catch (error) {
            console.error("Error during initialization:", error);
        }
        setDataFetched(true);
    };

    const handleChangeCheckbox = (event) => {
        const { name, checked } = event.target;
        const updatedCheckboxValues = {
            ...checkboxValues,
            [name]: checked
        };

        setCheckboxValues(updatedCheckboxValues);

    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setCheckoutData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const handhleChangeCaditData = (event) => {
        const { name, value } = event.target;
        setCaditData(prevData => ({
            ...prevData,
            [name]: value
        }));
    }

    const handleCheckPeople = async (date, time) => {
        try {
            const res = await GetSpecialDateTime(date, time);
            if (!res || res.length === 0) {
                const res = await GetTimeSlotsByTime(time)
                if (!res || res.length === 0) {
                    return 0
                } else {
                    if (res.status === 'active') {
                        setMaxPeople(res.total_people)
                        return res.total_people
                    } else {
                        setMaxPeople(0)
                        return 0
                    }
                }
            } else {
                if (res.status === 'active') {
                    setMaxPeople(res.total_people)
                    return res.total_people
                } else {
                    setMaxPeople(0)
                    return 0
                }
            }
        } catch (error) {
            console.error(error);
            throw new Error(error.message);
        }
    }

    function convertDateFormat(dateString) {
        // console.log(`Converting ${dateString}`, 'start');

        // Regex สำหรับตรวจสอบ MM/YYYY
        const regex = /^(0[1-9]|1[0-2])\/([0-9]{4})$/;
        const match = dateString.match(regex);

        if (match) {
            // console.log(`Converting ${dateString}`, 'end');
            return {
                m: match[1], // MM
                y: match[2], // YYYY
            };
        } else {
            throw new Error("Invalid date format. Please use MM/YYYY.");
        }
    }

    const validateBookingData = (data) => {
        let requiredFields = [
            'date', 'time', 'adults', 'children', 'total_people', 'vat', 'total_price',
            'first_name', 'last_name', 'email', 'tel', 'address'
        ];

        if (isThai) {
            requiredFields.push('province', 'district', 'subdistrict', 'zip_code');
        } else {
            requiredFields.push('address_details');
        }

        const emptyFields = requiredFields.filter(field => {
            const value = data[field];
            return value === undefined || value === null || value === '' ||
                (typeof value === 'number' && isNaN(value));
        });

        setValid(prevValid => {
            // Create a copy of the previous state
            const newValid = { ...prevValid };
            // Loop through each required field
            requiredFields.forEach(field => {
                // Set the valid state to true if the field is empty
                newValid[field] = emptyFields.includes(field);
            });
            return newValid;
        });

        if (emptyFields.length > 0) {
            return {
                isValid: false,
                emptyFields: emptyFields
            };
        }
        return { isValid: true };
    };

    const CreditvalidateBookingData = (data) => {
        const requiredFields = ['name', 'cvv', 'number', 'month', 'year'];
        const fieldLengths = { number: 16, cvv: 3, month: 2, year: 4 };

        // ตรวจสอบฟิลด์ว่าง
        const emptyFields = requiredFields.filter(
            (field) => !data[field] || (typeof data[field] === 'number' && isNaN(data[field]))
        );

        // ตรวจสอบความยาวของฟิลด์
        const invalidLengthFields = Object.keys(fieldLengths).filter(
            (field) => data[field] && data[field].toString().length !== fieldLengths[field]
        );

        // รวมฟิลด์ที่ผิดพลาดทั้งหมด
        const allInvalidFields = [...emptyFields, ...invalidLengthFields];

        // อัปเดตสถานะฟิลด์
        setCreditValid((prevValid) => ({
            ...prevValid,
            ...Object.fromEntries(requiredFields.map((field) => [field, allInvalidFields.includes(field)]))
        }));

        // ตรวจสอบผลลัพธ์
        return {
            isValid: allInvalidFields.length === 0,
            emptyFields: allInvalidFields
        };
    };

    const formatDate = (dateString) => {
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) {
                throw new Error('Invalid date');
            }

            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
            const year = date.getFullYear();

            return `${day}-${month}-${year}`;
        } catch (error) {
            throw new Error('Invalid date format. Please enter a valid date.');
        }
    };

    const handleSelectBanking = (data) => {
        setM_banking(data)
    }

    const handleSubmitted = async () => {
        //loading
        AlertLoading()
        try {

            if (!(checkboxValues.serviceTerms && checkboxValues.personalData)) {
                throw new Error(checkoutText('error_text_appection'));
            }

            const allFalse = Object.values(checked).every(value => value === false);
            if (allFalse) {
                throw new Error(checkoutText('error_text_paymethod'));
            }

            if (!formatDateState) {
                setFormatDateState(true);
                const result = formatDate(checkoutData.date);
                checkoutData.date = result;
            }

            const max = await handleCheckPeople(checkoutData.date, checkoutData.time)

            const maxPeople = await handleChecPeopleBoat(max, checkoutData.date, checkoutData.time);
            const maxPeopleNum = Number(maxPeople); // แปลง maxPeople เป็น number
            const totalPeopleNum = Number(checkoutData.total_people); // แปลง total_people เป็น number

            // console.log(maxPeopleNum, totalPeopleNum); // log ค่าตัวเลขออกมาเพื่อตรวจสอบ

            if ((maxPeopleNum - totalPeopleNum) < 0) {
                // console.log("maxPeopleNum", maxPeopleNum);
                // console.log("totalPeopleNum", totalPeopleNum);
                throw new Error(checkoutText('error_text_people_boat')); // ถ้า maxPeople <= totalPeople ให้แจ้ง error
            }

            const validationResult = validateBookingData(checkoutData);
            if (!validationResult.isValid) {
                throw new Error(checkoutText('error_text_information'));
            } //Create Omise source

            if (checkoutData.tel.length !== 10) {
                setValid((prevState) => ({
                    ...prevState, // กระจายค่าเดิมทั้งหมด
                    tel: false,   // อัปเดตเฉพาะฟิลด์ tel
                }));
                throw new Error(checkoutText('error_text_information'));
            }
            let omiseRes
            let paymentData
            try {
                if (checked.Wallet_Payment === true) {
                    omiseRes = await CreateSource('truemoney_jumpapp', { amount: checkoutData.total_price, tel: truePhone });
                    paymentData = {
                        ticketId: checkoutData.id,
                        source: omiseRes.id,
                        amount: checkoutData.total_price,
                        type: "truemoney",

                    };
                } else if (checked.Credit == true) {
                    // console.log("cardit", 'True')
                    const data = caditData
                    const CraditvalidationResult = CreditvalidateBookingData(data);
                    if (!CraditvalidationResult.isValid) {
                        throw new Error(checkoutText('error_text_information'));
                    } //Create Omise source
                    data.amount = checkoutData.total_price
                    // console.log("CreateSource",'start')
                    omiseRes = await CreateSource('internet_banking_bay', data);
                    paymentData = {
                        ticketId: checkoutData.id,
                        source: omiseRes.id,
                        amount: checkoutData.total_price,
                        type: "card"
                    };
                    // console.log("CreateSource",'end')
                } else if (checked.Mobile === true) {
                    const data = { ...m_banking }
                    data.type = m_banking.type;
                    data.amount = checkoutData.total_price
                    // console.log("mobile", data)
                    omiseRes = await CreateSource("mobile", data);
                    paymentData = {
                        ticketId: checkoutData.id,
                        source: omiseRes.id,
                        amount: checkoutData.total_price,
                        type: data.type
                    };
                }
            } catch (error) {
                AlertError(error);
            }
            if (paymentData === undefined) {
                AlertError(checkoutText('error_text'), checkoutText('error_text_paymethodData'))
                return
            }
            // console.log('check', checked)
            // console.log('id : ', checkoutData.id);
            // console.log("total_price :", checkoutData.total_price);
            // console.log('Token ที่สร้าง:', omiseRes);
            const data = checkoutData
            data.serviceUpdates = checkboxValues.serviceUpdates
            data.serviceTerms = checkboxValues.serviceTerms
            data.personalData = checkboxValues.personalData
            data.chargeId = omiseRes.id
            if (data.country === undefined || data.country === null) {
                data.country = 764
            }
            console.log("submit : ", data);
            const booking = await AddTicketboat(data);

            // console.log("Test : ", paymentData);
            const Datapayment = paymentData
            Datapayment.booking_id = booking.bookingId
            Datapayment.ticket = booking.id
            const paymentState = await Getpayment(Datapayment);
            // console.log("paymentState :", paymentState);
            ['adults', 'children', 'time', 'total_prices', 'date'].forEach(cookie => Cookies.remove(cookie));
            // console.log("paymentState susecess :", paymentState);
            window.location.href = paymentState.redirectUrl;
        } catch (error) {
            console.error('Error in handleSubmitted:', error);
            AlertError(checkoutText('error_text'), error.message);
        }
    };

    const handleChangeAutocomplate = async (event, newValue, name) => {
        // console.log("newValue", newValue);

        if (name === "country") {
            if (newValue) {
                const updatedData = { ...checkoutData };  // Create a shallow copy of newData
                updatedData[name] = newValue.value;        // Update the country field in the copied data
                setCheckoutData(updatedData);
                setIsthai(newValue.value == 764)
            } else {
                const updatedData = { ...checkoutData };
                updatedData[name] = "";
                setCheckoutData(updatedData);
            }
            // console.log('updateData : ',updatedData)        // Set the updated state with the new data
            return;                              // Exit the function to prevent further execution
        }


        setCheckoutData(prevData => {
            const newData = { ...prevData };

            if (newValue) {
                switch (name) {
                    case 'zip_code':
                        newData[name] = newValue.zip_code;
                        break;
                    case 'subdistrict':
                        newData[name] = newValue.value;
                        newData["zip_code"] = "";
                        const currentSubdistricts = subdistrictDefaut.filter(d => newValue.value === d.value);
                        setZipCode(currentSubdistricts); // Update zip code based on selected subdistrict
                        setAutocomplateState({ province: true, district: true, setDistrict: true, zip_code: true });
                        break;
                    case 'province':
                        newData[name] = newValue.value;
                        newData["district"] = null;
                        newData["subdistrict"] = null;
                        newData["zip_code"] = null;
                        setDistrict(districtDefaut.filter(d => newValue.value === d.province_id));
                        setAutocomplateState({
                            province: true,
                            district: true,
                            subdistrict: false,
                            zip_code: false
                        });
                        break;
                    case 'district':
                        newData[name] = newValue.value;
                        newData["subdistrict"] = null;
                        newData["zip_code"] = null;
                        setSubdistrict(subdistrictDefaut.filter(d => newValue.value === d.district_id));
                        setAutocomplateState({ province: true, district: true, setDistrict: true, zip_code: false });
                        break;
                    default:
                        break;
                }
            } else {
                // Handle case when newValue is null
                switch (name) {
                    case 'zip_code':
                        newData[name] = "";
                        break;
                    case 'subdistrict':
                        newData[name] = "";
                        newData["zip_code"] = "";
                        setAutocomplateState({ province: true, district: true, setDistrict: true, zip_code: false });
                        break;
                    case 'province':
                        newData[name] = "";
                        newData["district"] = null;
                        newData["subdistrict"] = null;
                        newData["zip_code"] = null;
                        setAutocomplateState({
                            province: true,
                            district: false,
                            subdistrict: false,
                            zip_code: false
                        });
                        break;
                    case 'district':
                        newData[name] = "";
                        newData["subdistrict"] = null;
                        newData["zip_code"] = null;
                        setAutocomplateState({ province: true, district: true, setDistrict: false, zip_code: false });
                        break;
                    default:
                        break;
                }
            }
            return newData;
        });
    };

    return (
        <Box>
            <Box
                sx={{
                    marginTop: '90px',
                    minHeight: '100vh',
                    width: '100%',
                    backgroundImage: `
          linear-gradient(to top, rgba(255, 255, 255, 255) 20%, rgba(0, 0, 0, 0) 100%),
          url(${bg_pic})
        `,
                    backgroundSize: '100% auto',
                    backgroundPosition: 'top', // ชิดขอบบน
                    backgroundRepeat: 'no-repeat',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start', // ชิดขอบบนของเนื้อหาด้านใน
                    width: '100%', // กว้างเต็มหน้าจอ
                    height: '100vh', // สูงเต็มหน้าจอ
                    minHeight: '100vh',
                    // overflow: 'hidden',
                    padding: isMobile ? 0 : theme.spacing(2),
                }}
            >
                {!isMobile && (
                    <div
                        style={{
                            position: 'absolute',
                            textAlign: 'center',
                            width: '60%',
                            border: '0px solid #f00',
                            marginTop: '20px',
                            color: '#fff',
                            fontFamily: 'STIX Two Text , prompt , serif',
                            letterSpacing: '3px',
                            textShadow: '1px 1px 3px #888',
                        }}>
                        <h1 style={{ fontSize: 28, marginBottom: '5px' }}>{title('title1')}</h1>
                        <h2 style={{ fontSize: 18, marginBottom: '10px' }}>{title('title2')}</h2>
                        <p style={{ fontSize: 16, marginTop: '0px' }}>{title('description')}</p>
                    </div>
                )}

                <Box sx={{
                    position: 'relative',
                    // minHeight: isMobile ? 'auto' : '64vh',
                    borderRadius: 3,
                    width: isMobile ? '100%' : '80%',
                    padding: '0px',
                    marginTop: isMobile ? '100px' : '190px',
                    padding: isMobile ? 0 : theme.spacing(1),
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        backgroundColor: 'white',
                        opacity: 0.8,
                        borderRadius: 'inherit',
                    }

                }}>
                    <Box display="flex" flexDirection={isMobile ? "column" : "row"} gap={2} sx={{ position: 'relative', zIndex: 1, }}>
                        <BookingAppBarComponent />
                        <Card sx={{ width: isMobile ? '93%' : '70%', padding: '16px', boxShadow: 5, paddingBottom: '0px' }}>
                            <CardContent>
                                {/* <Typography variant="h5" gutterBottom color={'black'} fontWeight={'bold'}>
                                    ข้อมูลการจอง
                                </Typography> */}

                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography variant="h5" color={'black'} fontWeight={'bold'}>
                                        {checkoutText('title')}
                                    </Typography>
                                    <Typography color={'black'} fontWeight={'bold'}>
                                        <Chip label={checkoutText('text_BackBtn')} variant="outlined" sx={{ margin: '0px 0px 10px 0px', padding: '4px 0px 0px 0px' }} onClick={handleBackClick} />
                                    </Typography>
                                </Box>

                                <Divider />

                                <Box margin={4} sx={{ marginLeft: '0px', marginRight: '0px' }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <Typography className='bookingDetailTitle'>
                                                {checkoutText('title_Date')}
                                            </Typography>
                                            <Typography className='bookingDetailValue'>
                                                {formatDateToThai(formattedData)}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Typography className='bookingDetailTitle'>
                                                {checkoutText('title_timeslot')}
                                            </Typography>
                                            <Typography className='bookingDetailValue'>
                                                {checkoutData.time} น.
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Typography className='bookingDetailTitle'>
                                                {checkoutText('title_passengers')}
                                            </Typography>
                                            <Typography className='bookingDetailValue'>
                                                {checkoutText('text_adults')} {checkoutData.adults} {checkoutText('text_unitperson')} ,
                                                {checkoutText('text_children')} {checkoutData.children} {checkoutText('text_unitperson')}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Typography className='bookingDetailTitle'>
                                                {checkoutText('title_Services')}
                                            </Typography>
                                            <Typography className='bookingDetailValue'>
                                                <Chip label={checkoutText('chip_diver')} variant="outlined" sx={{ margin: '5px' }} />
                                                <Chip label={checkoutText('chip_insurance')} variant="outlined" sx={{ margin: '5px' }} />
                                                <Chip label={checkoutText('chip_water')} variant="outlined" sx={{ margin: '5px' }} />
                                                <Chip label={checkoutText('chip_wipe')} variant="outlined" sx={{ margin: '5px' }} />
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Box sx={{ fontSize: '14px', color: '#f00', textDecoration: 'italic', marginTop: '14px' }}>
                                                <strong>{checkoutText('title_note')}</strong>{checkoutText('text_note')}
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </CardContent>
                            <CardContent sx={{ paddingBottom: '0px' }}>
                                <Typography variant="h5" gutterBottom color={'black'} fontWeight={'bold'}>
                                    {checkoutText('title_customer')}
                                </Typography>
                                <Divider />
                                <Box margin={4} sx={{ marginLeft: '0px', marginRight: '0px' }}>
                                    <Grid item xs={12}>
                                        {/* <Typography>ที่อยู่ (เลขที่ / อาคาร / ถนน)</Typography> */}
                                        <Box sx={{ fontSize: '14px' }}>
                                            {checkoutText('title_description')}  <a href="https://trueleasing.co.th/th/pages/privacynotice" target='_blank'>{checkoutText('clickme')}</a>
                                        </Box><br></br>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <Typography>{checkoutText('title_customerFirstName')}</Typography>
                                            <Box>
                                                <TextField className='bookingTextField'
                                                    name="first_name"
                                                    fullWidth
                                                    label={checkoutText('title_customerFirstName')}
                                                    variant="outlined"
                                                    error={valid.first_name}
                                                    value={checkoutData.firstName}
                                                    onChange={handleChange}
                                                />
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Typography>{checkoutText('title_customerLastName')}</Typography>
                                            <Box>
                                                <TextField className='bookingTextField'
                                                    name="last_name"
                                                    margin='16px'
                                                    fullWidth
                                                    label={checkoutText('title_customerLastName')}
                                                    variant="outlined"
                                                    value={checkoutData.lastName}
                                                    error={valid.last_name}
                                                    onChange={handleChange}
                                                />
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Typography>{checkoutText('title_customerEmail')}</Typography>
                                            <Box>
                                                <TextField className='bookingTextField'
                                                    name="email"
                                                    margin='16px'
                                                    fullWidth
                                                    label={checkoutText('title_customerEmail')}
                                                    variant="outlined"
                                                    value={checkoutData.email}
                                                    error={valid.email}
                                                    onChange={handleChange}
                                                />
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Typography>{checkoutText('title_customerPhone')}</Typography>
                                            <TextField
                                                fullWidth
                                                margin='16px'
                                                label={checkoutText('title_phonepaymenttruewallet')}
                                                variant="outlined"
                                                name="tel"
                                                value={checkoutData.tel}
                                                error={valid.tel}
                                                onChange={(e) => {
                                                    const newValue = e.target.value.replace(/[^0-9]/g, ''); // Allows only numbers
                                                    handleChange({ target: { name: 'tel', value: newValue } });
                                                }}
                                                inputProps={{ maxLength: 10 }} // Set a max length for phone numbers if desired
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Typography>{checkoutText('title_customerCountry')}</Typography>
                                            <Autocomplete
                                                className="bookingTextField"
                                                id="country-select"
                                                options={country}
                                                name="country"
                                                getOptionLabel={(option) => option.label}
                                                renderInput={(params) => (
                                                    <TextField
                                                        error={valid.country}
                                                        {...params}
                                                        label={checkoutText('title_customerCountry')}
                                                    />
                                                )}
                                                // Ensure value is either a valid country object or null (default)
                                                value={country.find(p => p.value == (checkoutData.country ?? 764)) || null}
                                                onChange={(e, newValue) => handleChangeAutocomplate(e, newValue, "country")}
                                                fullWidth
                                                disableListWrap
                                                ListboxProps={{
                                                    style: {
                                                        maxHeight: '250px',
                                                        overflow: 'auto',
                                                    },
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography>
                                                {checkoutText('title_customerAddress')}
                                            </Typography>
                                            <Box>
                                                <TextField
                                                    className="bookingTextField"
                                                    name="address"
                                                    fullWidth
                                                    label={checkoutText('title_customerAddress')}
                                                    variant="outlined"
                                                    value={checkoutData.address}
                                                    error={valid.address}
                                                    onChange={handleChange}
                                                    multiline
                                                    rows={4} // กำหนดจำนวนแถว เช่น 4 แถว
                                                />
                                            </Box>
                                        </Grid>
                                        {!isThai && (
                                            <Grid item xs={12}>
                                                <Typography>
                                                    {checkoutText('title_customerAddressDetail')}
                                                </Typography>
                                                <Box>
                                                    <TextField
                                                        className="bookingTextField"
                                                        name="address_details"
                                                        fullWidth
                                                        label={checkoutText('title_customerAddressDetail')}
                                                        variant="outlined"
                                                        value={checkoutData.address_details}
                                                        error={valid.address_details}
                                                        onChange={handleChange}
                                                        multiline
                                                        rows={4}
                                                    />
                                                </Box>
                                            </Grid>
                                        )}
                                        {isThai && (
                                            <Grid item xs={12} md={6}>
                                                <Typography>{checkoutText('title_customerProvince')}</Typography>
                                                <Box>
                                                    <Autocomplete className='bookingTextField'
                                                        id="province-select"
                                                        options={province}
                                                        name="province"
                                                        getOptionLabel={(option) => option.label}
                                                        renderInput={(params) => <TextField error={valid.province} {...params} label={checkoutText('title_customerProvince')} />}
                                                        value={province.find(p => p.value === checkoutData.province) || null}
                                                        onChange={(e, newValue) => handleChangeAutocomplate(e, newValue, "province")}
                                                        fullWidth
                                                        disableListWrap
                                                        ListboxProps={{
                                                            style: {
                                                                maxHeight: '250px',
                                                                overflow: 'auto',
                                                            },
                                                        }}
                                                    />
                                                </Box>
                                            </Grid>
                                        )
                                        }

                                        {
                                            isThai && (
                                                <Grid item xs={12} md={6}>
                                                    <Typography>{checkoutText('title_customerDistrict')}</Typography>
                                                    <Box>
                                                        <Autocomplete className='bookingTextField'
                                                            id="district-select"
                                                            options={district}
                                                            name="district"
                                                            getOptionLabel={(option) => option.label}
                                                            renderInput={(params) => <TextField error={valid.district} {...params} label={checkoutText('title_customerDistrict')} />}
                                                            value={district.find(p => p.value === checkoutData.district) || null}
                                                            onChange={(e, newValue) => handleChangeAutocomplate(e, newValue, "district")}
                                                            fullWidth
                                                            ListboxProps={{
                                                                style: {
                                                                    maxHeight: '250px',
                                                                    overflow: 'auto',
                                                                },
                                                            }}
                                                            disabled={!AutocompleteState.district}
                                                        />
                                                    </Box>
                                                </Grid>
                                            )
                                        }

                                        {
                                            isThai && (
                                                <Grid item xs={12} md={6}>
                                                    <Typography>{checkoutText('title_customerSubDistrict')}</Typography>
                                                    <Box>
                                                        <Autocomplete className='bookingTextField'
                                                            id="subdistrict-select"
                                                            options={subdistrict}
                                                            name="SubDistrict"
                                                            getOptionLabel={(option) => option.label}
                                                            renderInput={(params) => <TextField error={valid.subdistrict} {...params} label={checkoutText('title_customerSubDistrict')} />}
                                                            value={subdistrict.find(p => p.value === checkoutData.subdistrict) || null}
                                                            onChange={(e, newValue) => handleChangeAutocomplate(e, newValue, "subdistrict")}
                                                            fullWidth
                                                            ListboxProps={{
                                                                style: {
                                                                    maxHeight: '250px',
                                                                    overflow: 'auto',
                                                                },
                                                            }}
                                                            disabled={!AutocompleteState.setDistrict}
                                                        />
                                                    </Box>
                                                </Grid>
                                            )
                                        }
                                        {
                                            isThai && (
                                                <Grid item xs={12} md={6}>
                                                    <Typography>{checkoutText('title_customerPostcode')}</Typography>
                                                    <Box>
                                                        <Autocomplete className='bookingTextField'
                                                            id="zip_code"
                                                            options={zip_code}
                                                            name="zip_code"
                                                            getOptionLabel={(option) => option.zip_code}
                                                            renderInput={(params) => <TextField error={valid.zip_code} {...params} label={checkoutText('title_customerPostcode')} name='zip_code' />}
                                                            value={zip_code.find(p => p.zip_code === checkoutData.zip_code) || null}
                                                            onChange={(e, newValue) => handleChangeAutocomplate(e, newValue, "zip_code")}
                                                            fullWidth

                                                            ListboxProps={{
                                                                style: {
                                                                    maxHeight: '250px',
                                                                    overflow: 'auto',
                                                                },
                                                            }}
                                                            disabled={!AutocompleteState.zip_code}
                                                        />
                                                    </Box>
                                                </Grid>
                                            )
                                        }
                                        <Grid item xs={12} md={12}>
                                            <Typography>{checkoutText('title_point')}</Typography>
                                            <Box >
                                                <TextField className='bookingTextField'
                                                    name="note"
                                                    fullWidth
                                                    label={checkoutText('text_point')}
                                                    variant="outlined"
                                                    value={checkoutData.note}
                                                    onChange={handleChange}
                                                />
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </CardContent>
                            <CardContent sx={{ paddingTop: '0px' }}>
                                <Typography variant="h5" gutterBottom color={'black'} fontWeight={'bold'} sx={{ paddingTop: '0px' }}>
                                    {checkoutText('title_paymentmethod')}
                                </Typography>
                                <Divider />
                                <Box>
                                    <Box sx={{ width: '100%', margin: 'auto' }}>
                                        {accordionData.map((item) => (
                                            <Accordion
                                                key={item.id}
                                                expanded={expanded === item.id}
                                                onChange={handleAccordionChange(item.id)}
                                                sx={{
                                                    '&:before': {
                                                        display: 'none',
                                                    },
                                                    borderRadius: '4px',
                                                    mb: 1,
                                                    boxShadow: 1,
                                                }}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls={`${item.id}-content`}
                                                    id={`${item.id}-header`}
                                                    sx={{
                                                        flexDirection: 'row-reverse',
                                                        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
                                                            transform: 'rotate(180deg)',
                                                        },
                                                        '& .MuiAccordionSummary-content': {
                                                            marginLeft: 2,
                                                        },
                                                    }}
                                                >
                                                    <FormControlLabel
                                                        aria-label="Acknowledge"
                                                        onClick={(event) => event.stopPropagation()}
                                                        onFocus={(event) => event.stopPropagation()}
                                                        control={
                                                            <Checkbox
                                                                checked={checked[item.id]}
                                                                onChange={handleCheckboxChange(item.id)}
                                                                sx={{ '&:hover': { bgcolor: 'transparent' } }}
                                                            />
                                                        }
                                                        label={
                                                            <Box display="flex" alignItems="center" padding="8px">
                                                                {/* <Box
                                                                    component="img"
                                                                    src={item.imgUrl}
                                                                    sx={{
                                                                        width: '60px',
                                                                        height: '50px',
                                                                        marginRight: '12px', // เพิ่มระยะห่างระหว่างรูปภาพและข้อความ
                                                                        borderRadius: '4px', // เพิ่มมุมโค้งเล็กน้อยเพื่อให้ดูนุ่มนวล
                                                                    }}
                                                                    alt={`${item.label} image`} // Provide an alt text for accessibility
                                                                /> */}
                                                                <Typography variant="subtitle1" fontWeight="bold" color="text.primary">
                                                                    {item.label}
                                                                </Typography>
                                                            </Box>

                                                        }
                                                    />
                                                </AccordionSummary>
                                                <AccordionDetails>


                                                    {/* <Typography>{item.content}</Typography> */}
                                                    {item.id == 'Wallet_Payment' &&

                                                        <Box sx={{ maxWidth: 600, mx: 'auto', p: 3 }}>
                                                            <Card
                                                                sx={{
                                                                    mb: 2,
                                                                    background: stateWallet ? '#F0F8FF' : '#FFFFFF',
                                                                    cursor: 'pointer',
                                                                    border: stateWallet ? '2px solid #1E90FF' : 'none',
                                                                    boxShadow: stateWallet ? '0 4px 12px rgba(0, 0, 0, 0.4)' : '0 2px 8px rgba(0, 0, 0, 0.2)',
                                                                    transition: 'background 0.3s, box-shadow 0.3s',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    padding: 1,
                                                                }}
                                                                onClick={(e) => setStateWallet(true)}
                                                            >
                                                                {/* Square Avatar for Menu Icon */}
                                                                <Avatar
                                                                    src={item.imgUrl} // URL for each menu item's image
                                                                    alt="True money"
                                                                    variant="square" // Make the Avatar a square shape
                                                                    sx={{ width: 48, height: 48, mr: 2 }}
                                                                />
                                                                <CardContent sx={{ flex: '1 1 auto' }}>
                                                                    <Typography variant="h6">{item.title}</Typography>
                                                                    <Typography variant="body2" color="text.secondary" fontWeight={'bold'}>
                                                                        {item.content}
                                                                    </Typography>
                                                                </CardContent>
                                                            </Card>
                                                        </Box>
                                                    }

                                                    {
                                                        item.id === "Mobile" && (
                                                            <Box sx={{ maxWidth: 600, mx: 'auto' }}>
                                                                {item.id === "Mobile" && (
                                                                    item.content.map((menuItem) => (
                                                                        <Card
                                                                            key={menuItem.id}
                                                                            sx={{
                                                                                mb: 2,
                                                                                background: m_banking.id === menuItem.id ? '#F0F8FF' : '#FFFFFF',
                                                                                cursor: 'pointer',
                                                                                border: m_banking.id === menuItem.id ? '2px solid #1E90FF' : 'none',
                                                                                boxShadow: m_banking.id === menuItem.id ? '0 4px 12px rgba(0, 0, 0, 0.4)' : '0 2px 8px rgba(0, 0, 0, 0.2)',
                                                                                transition: 'background 0.3s, box-shadow 0.3s',
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                padding: 1,
                                                                            }}
                                                                            onClick={(e) => handleSelectBanking(menuItem)}
                                                                        >
                                                                            {/* Square Avatar for Menu Icon */}
                                                                            <Avatar
                                                                                src={menuItem.imgUrl} // URL for each menu item's image
                                                                                alt={menuItem.title}
                                                                                variant="square" // Make the Avatar a square shape
                                                                                sx={{ width: 48, height: 48, mr: 2 }}
                                                                            />
                                                                            <CardContent sx={{ flex: '1 1 auto' }}>
                                                                                <Typography variant="h6">{menuItem.title}</Typography>
                                                                                <Typography variant="body2" color="text.secondary" fontWeight={'bold'}>
                                                                                    {menuItem.label}
                                                                                </Typography>
                                                                            </CardContent>
                                                                        </Card>
                                                                    ))
                                                                )}
                                                            </Box>
                                                        )
                                                    }

                                                    {item.id == 'Credit' &&

                                                        <Card sx={{ maxWidth: 600, mx: 'auto', p: 3, background: '#FCFCFC' }}>
                                                            <CardContent>
                                                                {/* Credit Card Image */}
                                                                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
                                                                    <Box
                                                                        component="img"
                                                                        src={item.imgUrl}
                                                                        sx={{ width: 140, height: 140, objectFit: 'contain' }}
                                                                        alt="Credit Card"
                                                                    />
                                                                </Box>

                                                                {/* Card Number */}
                                                                <Box sx={{ mb: 3 }}>
                                                                    <Typography variant="body1" sx={{ mb: 1 }}>
                                                                        {checkoutText('title_carditnumber')}
                                                                    </Typography>
                                                                    <TextField
                                                                        fullWidth
                                                                        size="small"
                                                                        label={checkoutText('title_carditnumber')}
                                                                        variant="outlined"
                                                                        name="number"
                                                                        type={showCraditNumber ? "text" : 'password'}
                                                                        value={caditData.number}
                                                                        error={Creditvalid.number}
                                                                        onChange={(e) => {
                                                                            // Only allow numeric input
                                                                            const newValue = e.target.value.replace(/[^0-9]/g, '');
                                                                            handhleChangeCaditData({ target: { name: 'number', value: newValue } });
                                                                        }}
                                                                        inputProps={{
                                                                            maxLength: 16,
                                                                            inputMode: 'numeric',
                                                                            pattern: '[0-9]*',
                                                                        }}
                                                                        InputProps={{
                                                                            endAdornment: (
                                                                                <InputAdornment position="end">
                                                                                    <IconButton
                                                                                        // onClick logic for toggling visibility if needed
                                                                                        onClick={(e) => setShowCraditNumber(!showCraditNumber)}
                                                                                        edge="end"
                                                                                    >
                                                                                        {showCraditNumber ? <VisibilityOff /> : <Visibility />}
                                                                                    </IconButton>
                                                                                </InputAdornment>
                                                                            ),
                                                                        }}
                                                                    />
                                                                </Box>

                                                                {/* Cardholder Name */}
                                                                <Box sx={{ mb: 3 }}>
                                                                    <Typography variant="body1" sx={{ mb: 1 }}>
                                                                        {checkoutText('title_carditname')}
                                                                    </Typography>
                                                                    <TextField
                                                                        fullWidth
                                                                        size="small"
                                                                        label={checkoutText('title_carditname')}
                                                                        variant="outlined"
                                                                        name='name'
                                                                        value={caditData.name}
                                                                        error={Creditvalid.name}
                                                                        onChange={handhleChangeCaditData}
                                                                    />
                                                                </Box>

                                                                {/* Expiry Date and CVV */}
                                                                <Box sx={{ display: 'flex', gap: 2 }}>
                                                                    <Box sx={{ flex: 1 }}>
                                                                        <Typography variant="body1" sx={{ mb: 1 }}>
                                                                            {checkoutText('title_carditExMonth')}
                                                                        </Typography>
                                                                        <TextField
                                                                            fullWidth
                                                                            size="small"
                                                                            label={"MM"}
                                                                            variant="outlined"
                                                                            name="month"
                                                                            value={caditData.ex}
                                                                            onChange={(e) => {
                                                                                const { value } = e.target;
                                                                                if (/^\d*$/.test(value)) {  // Only allow digits
                                                                                    handhleChangeCaditData(e);
                                                                                }
                                                                            }}
                                                                            error={Creditvalid.month}
                                                                            inputProps={{ maxLength: 2, inputMode: 'numeric', pattern: '[0-9]*' }}
                                                                        />
                                                                    </Box>
                                                                    <Box sx={{ flex: 1 }}>
                                                                        <Typography variant="body1" sx={{ mb: 1 }}>
                                                                            {checkoutText('title_carditExYear')}
                                                                        </Typography>
                                                                        <TextField
                                                                            fullWidth
                                                                            size="small"
                                                                            label={"YYYY"}
                                                                            variant="outlined"
                                                                            name="year"
                                                                            value={caditData.ex}
                                                                            onChange={(e) => {
                                                                                const { value } = e.target;
                                                                                if (/^\d*$/.test(value)) {  // Only allow digits
                                                                                    handhleChangeCaditData(e);
                                                                                }
                                                                            }}
                                                                            error={Creditvalid.year}
                                                                            inputProps={{ maxLength: 4, inputMode: 'numeric', pattern: '[0-9]*' }}
                                                                        />
                                                                    </Box>
                                                                    <Box sx={{ flex: 1 }}>
                                                                        <Typography variant="body1" sx={{ mb: 1 }}>
                                                                            CVV
                                                                        </Typography>
                                                                        <TextField
                                                                            fullWidth
                                                                            size="small"
                                                                            label="CVV"
                                                                            variant="outlined"
                                                                            name="cvv"
                                                                            type={showCVV ? "text" : "password"}
                                                                            inputProps={{ maxLength: 3, inputMode: 'numeric', pattern: '[0-9]*' }}
                                                                            onChange={(e) => {
                                                                                const { value } = e.target;
                                                                                if (/^\d*$/.test(value)) {  // Only allow digits
                                                                                    handhleChangeCaditData(e);
                                                                                }
                                                                            }}
                                                                            error={Creditvalid.cvv}
                                                                            value={caditData.cvv}
                                                                            InputProps={{
                                                                                endAdornment: (
                                                                                    <InputAdornment position="end">
                                                                                        <IconButton
                                                                                            // onClick logic for toggling visibility if needed
                                                                                            onClick={(e) => setShowCVV(!showCVV)}
                                                                                            edge="end"
                                                                                        >
                                                                                            {showCVV ? <VisibilityOff /> : <Visibility />}
                                                                                        </IconButton>
                                                                                    </InputAdornment>
                                                                                ),
                                                                            }}
                                                                        />
                                                                    </Box>
                                                                </Box>
                                                            </CardContent>
                                                        </Card>
                                                    }
                                                </AccordionDetails>
                                            </Accordion>
                                        ))}
                                    </Box>
                                </Box>
                            </CardContent>


                            <CardContent>
                                <Typography variant="h5" gutterBottom color={'black'} fontWeight={'bold'}>
                                    {checkoutText('title_condition')}
                                </Typography>
                                <Divider />
                                <Box marginTop={'10px'} className="serviceConditionDetails">
                                    {Rules.map((section, index) => (
                                        <React.Fragment key={index}>
                                            <Typography gutterBottom sx={{ mt: 2, color: 'black', fontSize: '16px', fontWeight: '500' }}>
                                                {rules(section.title)}
                                            </Typography>
                                            <List>
                                                {section.items.map((item, itemIndex) => (
                                                    <ListItem key={itemIndex}>
                                                        <Typography sx={{ fontSize: '14px', whiteSpace: "pre-line" }}>{rules(item)}</Typography>
                                                    </ListItem>
                                                ))}
                                            </List>
                                        </React.Fragment>
                                    ))}
                                </Box>
                                <Box margin={'25px 10px 0px 10px'}>
                                    <FormGroup sx={{ fontSize: '14px' }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    required
                                                    name="serviceTerms"
                                                    checked={checkboxValues.serviceTerms}
                                                    onChange={handleChangeCheckbox}
                                                />
                                            }
                                            label={checkoutText('title_checkbox1')}
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    required
                                                    name="personalData"
                                                    checked={checkboxValues.personalData}
                                                    onChange={handleChangeCheckbox}
                                                />
                                            }
                                            label={checkoutText('title_checkbox2')}
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    name="serviceUpdates"
                                                    checked={checkboxValues.serviceUpdates}
                                                    onChange={handleChangeCheckbox}
                                                />
                                            }
                                            label={checkoutText('title_checkbox3')}
                                        />
                                    </FormGroup>
                                </Box>
                            </CardContent>
                        </Card>
                        {/* <Card className='summary-box' sx={{ width: isMobile ? '93%' : '30%', minWidth: '30%', height: isMobile ? '40vh' : '30vh', boxShadow: 5, padding: 2, margin: '2px' }}> */}
                        <Card className='summary-box' sx={{
                            width: isMobile ? '93%' : '30%',
                            minWidth: '30%',
                            height: isMobile ? '60vh' : '44vh',
                            boxShadow: 5,
                            padding: 2,
                            margin: 2
                        }}>
                            <CardContent sx={{ padding: '0' }}>
                                <Typography variant="h5" gutterBottom fontWeight="bold">
                                    {checkoutText('title_totalprice')}
                                </Typography>
                                <Divider />
                            </CardContent>

                            <Box display="flex" flexDirection="row" gap={2} justifyContent="space-between" padding={2}>
                                <TextField
                                    className='bookingTextField'
                                    name="discountCode"
                                    margin="16px"
                                    fullWidth
                                    label={checkoutText('text_codeBtn')}
                                    sx={{ border: 'none' , marginTop: 3, }}
                                />
                                <Button
                                    variant="contained"
                                    sx={{
                                        width: '100px',
                                        height: '55px',
                                        marginTop: 1,
                                        bgcolor: "#55D0E4"
                                    }}
                                    fullWidth
                                    margin="16px"
                                    disableElevation
                                >
                                    {checkoutText('title_codeBtn')}
                                </Button>
                            </Box>

                            <Divider sx={{ margin: '5px 0px 10px 0px', borderColor: '#efefef' }} />

                            {[
                                { label: 'title2_totalprice', value: checkoutData.priceBeforeVAT },
                                { label: 'text_vat', value: checkoutData.vat },
                                { label: 'text_discount', value: checkoutData.discountAmount }
                            ].map((item, index) => (
                                <Box key={index} display="flex" flexDirection="row" gap={2} justifyContent="space-between" padding={2}>
                                    <Typography gutterBottom sx={{ fontSize: '15px', fontWeight: 'bold' }}>
                                        {checkoutText(item.label)}
                                    </Typography>
                                    <Typography gutterBottom sx={{ fontSize: '16px', fontWeight: 'bold' }}>
                                        {(item.value !== undefined && item.value !== null
                                            ? item.value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                            : '0.00')}
                                    </Typography>
                                </Box>
                            ))}

                            {[
                                { label: 'text_adults', count: checkoutData.adults, price: checkoutData.sumAdultPriceBfVAT },
                                { label: 'text_children', count: checkoutData.children, price: checkoutData.sumChildrenPriceBfVAT }
                            ].map((item, index) => (
                                <Box key={index} display="flex" flexDirection="row" gap={2} justifyContent="space-between" padding={2}>
                                    <Typography gutterBottom sx={{ fontSize: '14px', fontStyle: 'italic', paddingLeft: 2 }}>
                                        - {checkoutText(item.label)} {item.count} {checkoutText('text_unitperson')}
                                    </Typography>
                                    <Typography gutterBottom sx={{ fontSize: '14px', fontStyle: 'italic' }}>
                                        {(item.price !== undefined && item.price !== null
                                            ? item.price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                            : '0.00')}
                                    </Typography>
                                </Box>
                            ))}

                            <Divider sx={{ margin: '5px 0px 10px 0px', borderColor: '#eee' }} />

                            <Box display="flex" flexDirection="row" gap={2} justifyContent="space-between" padding={2}>
                                <Typography gutterBottom fontWeight="bold" color="#55D0E4" fontSize="22px">
                                    {checkoutText('title_totalnetprice')}
                                </Typography>
                                <Typography gutterBottom fontWeight="bold" color="#55D0E4" fontSize="24px">
                                    {(checkoutData.total_price !== undefined && checkoutData.total_price !== null
                                        ? checkoutData.total_price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                        : '0.00')}
                                </Typography>
                            </Box>

                            <Box>
                                <Button
                                    className='BookNow_Btn_Booking_page'
                                    onClick={handleSubmitted}
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    sx={{
                                        borderRadius: '50px',
                                        margin: '20px 0px 10px 0px',
                                        width: '100%',
                                        backgroundColor: '#55D0E4'
                                    }}
                                >
                                    <h3 style={{ margin: 0 }}>{checkoutText('text_submit')}</h3>
                                </Button>
                            </Box>
                        </Card>

                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default CheckoutView;